import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import {
  ApproveMerchantRequests,
  GetMerchantHGOFilteredRequests,
  GetMerchantHGORequests,
  GetMerchantMonazamFilteredRequests,
  GetMerchantMonazamRequests,
  RejectMerchantRequests,
} from "../../../../../Actions/RequestActions";
import { SuccessToast } from "../../../../../Util";
const Table = ({ reload, filters, page, setPage, setTotalPages }) => {
  const { userType } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMerchantRequests = async () => {
    setLoading(true);
    setError("");
    if (userType === "monazam") {
      GetMerchantMonazamRequests(
        setData,
        setLoading,
        setError,
        page,
        setTotalPages
      );
    } else if (userType === "hgo") {
      GetMerchantHGORequests(
        setData,
        setLoading,
        setError,
        page,
        setTotalPages
      );
    }
  };

  const fetchFilteredMerchantRequests = async () => {
    setLoading(true);
    setError("");
    if (userType === "monazam") {
      GetMerchantMonazamFilteredRequests(
        filters,
        setData,
        setLoading,
        setError,
        1,
        setTotalPages
      );
    } else if (userType === "hgo") {
      GetMerchantHGOFilteredRequests(
        filters,
        setData,
        setLoading,
        setError,
        1,
        setTotalPages
      );
    }
    setPage(1);
  };

  const handleApprove = () => {
    SuccessToast("Request approved successfully.");
    fetchMerchantRequests();
  };

  const handleReject = () => {
    SuccessToast("Request rejected successfully.");
    fetchMerchantRequests();
  };

  const approveRequest = (request) => {
    ApproveMerchantRequests(request.id, setError, handleApprove);
  };

  const rejectRequest = (request) => {
    RejectMerchantRequests(request.id, setError, handleReject);
  };

  useEffect(() => {
    if (!filters?.date) {
      fetchMerchantRequests();
    } else {
      fetchFilteredMerchantRequests();
    }
  }, [reload, userType, filters, page]);

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center loading-container">
        <Spinner animation="border" className="spinner-green" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  else if (!!error) return <p>{error}</p>;
  else
    return (
      <div>
        <div className="table-responsive">
          <table className="table">
            <colgroup>
              {userType === "monazam" && <col style={{ width: "12%" }} />}
              <col style={{ width: "12%" }} />
              <col style={{ width: "30%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "16%" }} />
              <col style={{ width: userType === "monazam" ? "18%" : "10%" }} />
            </colgroup>
            <thead>
              <tr>
                {userType === "monazam" && <th className="tableheader-txt-merchent">HGO Name</th>}
                <th className="tableheader-txt-merchent">Date</th>
                <th className="tableheader-txt-merchent">Narration</th>
                <th className="tableheader-txt-merchent">Amount</th>
                <th className="tableheader-txt-merchent">Voucher ID</th>
                <th className="tableheader-txt-merchent">
                  {userType === "monazam" ? "Actions" : "Status"}
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((request, index) => (
                <tr key={index}>
                  {userType === "monazam" && (
                    <td className="tabledata-txt py-3">
                      {request.hgoUser?.name || "N/A"}
                    </td>
                  )}
                  <td className="tabledata-txt py-3">
                    {new Date(request.date).toISOString().split("T")[0]}
                  </td>
                  <td className="tabledata-txt py-3">{request.narration}</td>
                  <td className="tabledata-txt py-3">{request.amount}</td>
                  <td className="tabledata-txt py-3">{request.voucherId}</td>
                  {userType === "monazam" && request.status === "pending" ? (
                    <td className="tabledata-txt py-3">
                      <button
                        className="btn btn-sm approved-btn rounded me-2"
                        onClick={() => {
                          approveRequest(request);
                        }}
                      >
                        Approve
                      </button>
                      <button
                        className="btn btn-sm rejectbtn rounded"
                        onClick={() => {
                          rejectRequest(request);
                        }}
                      >
                        Reject
                      </button>
                    </td>
                  ) : (
                    <td className="tabledata-txt py-3">
                      {request.status === "rejected" ? (
                        <button className="btn btn-sm rejectbtn me-2" disabled>
                          Rejected
                        </button>
                      ) : (
                        <button className="btn btn-sm approved-btn me-2" disabled>
                          {request.status}
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
};

export default Table;
